import { Button, Loading } from 'components'
import { useAccountActions } from 'hooks/userHooks'
import { useEffect } from 'react'
import { noop } from 'utils'

export type ReactivateBtnProps = {
  userId: string
  disabled?: boolean
  onDone?: (message: string) => void
  onError?: (message: string) => void
}

export const ReactivateBtn = ({
  userId,
  disabled = false,
  onDone = noop,
  onError = noop,
}: ReactivateBtnProps) => {
  const [state, { reactivate }] = useAccountActions()

  useEffect(() => {
    if (state.matches('success')) {
      onDone('User has been Reactivated')
    } else if (state.matches('failed')) {
      onError('Failed Reactivating User')
    }
  }, [state, onDone, onError])

  return (
    <>
      <Button
        variant="white"
        type="button"
        sx={{
          minWidth: 170,
          height: 49,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
        disabled={disabled || state.matches('syncing')}
        onClick={() => reactivate({ userId })}>
        {state.matches('syncing') ? <Loading /> : <span>Reactivate</span>}
      </Button>
    </>
  )
}
